import './global.css';

import * as React from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import Activity from 'src/entities/Activity';
import Group from 'src/entities/Group';
import Member from 'src/entities/Member';

import { updateMember } from '../../actions/member';
import Calendar from '../../res/img/calendar_white.svg';
// import Bell from '../../res/img/bell_white.svg';
import LogoImage from '../../res/img/logo_image.svg';
import LogoText from '../../res/img/logo_text.svg';
import Loupe from '../../res/img/loupe_white.svg';
import Profile from '../../res/img/member.svg';
import PlusWhite from '../../res/img/plus_white.svg';

interface IProps {
  isLogoOnly?: boolean;
  isVisiter?: boolean;
  account: Member;
  groups: Group[];
  members: Member[];
  activities: Activity[];
  group?: string;
  updateMember: (member: Member) => void;
}

interface IState {
  group: string;
  groupSelected: boolean;
  createAssigned: boolean;
  expandNotifications: boolean;
  createGlobalDisplayed: boolean;
}

class NavigationComponent extends React.Component<IProps, IState> {
  createGlobalSelect: HTMLSelectElement;

  constructor(props: any) {
    super(props);
    this.state = {
      group: this.props.group !== undefined ? this.props.group : '',
      groupSelected: false,
      createAssigned: false,
      expandNotifications: false,
      createGlobalDisplayed: false
    };

    this.toggleNotifications = this.toggleNotifications.bind(this);
    this.showCreateGlobal = this.showCreateGlobal.bind(this);
    this.hideCreateGlobal = this.hideCreateGlobal.bind(this);
  }

  componentDidUpdate() {
    if (
      this.props.group !== undefined &&
      this.state.group !== this.props.group
    ) {
      this.setState({
        group: this.props.group
      });
    }
  }

  render() {
    // const countNewActivities = this.props.activities.filter(
    //   activity =>
    //     activity.created > this.props.account.activityChecked &&
    //     activity.memberId !== this.props.account.id &&
    //     this.props.groups.map(group => group.id).includes(activity.groupId)
    // ).length;

    if (this.state.groupSelected) {
      this.setState({
        groupSelected: false
      });
      const path = window.location.pathname
        .split('/')
        .slice(2)
        .join('/');

      let pathname = '';
      if (this.state.group === '自分のメモ') {
        pathname = '/';
      } else if (this.state.group === 'システム管理') {
        pathname = '/admin/members';
      } else if (path.includes('memo')) {
        pathname = '/' + this.state.group + '/memos';
      } else if (path.includes('wiki')) {
        pathname = '/' + this.state.group + '/wikis';
      } else if (path.includes('note')) {
        pathname = '/' + this.state.group + '/notes';
      } else if (path.includes('settings/members')) {
        pathname = '/' + this.state.group + '/settings/members';
      } else if (path.includes('settings/functions')) {
        pathname = '/' + this.state.group + '/settings/functions';
      } else {
        pathname = '/' + this.state.group + '/memos';
      }

      // グループ遷移時にいろいろな値が更新されないので、location.hrefを使ってみる
      if (this.state.createAssigned) {
        pathname += '#create';
        open(pathname, '_blank');
      } else {
        location.href = pathname;
      }
    }

    const groupsAdmin = this.props.groups.filter(g =>
      g.admins.includes(this.props.account.id)
    );

    return (
      <div id="GlobalNavigation">
        <div id="GlobalNavigationLeft">
          {!this.props.isVisiter ? (
            <Link to="/">
              <div className="LogoImage">
                <img src={LogoImage} alt="MeetingMemo" />
              </div>
            </Link>
          ) : (
            <div className="LogoImage">
              <img src={LogoImage} alt="MeetingMemo" />
            </div>
          )}

          {this.props.isLogoOnly ? (
            <div>
              {!this.props.isVisiter ? (
                <Link to="/">
                  <div className="LogoText">
                    <img src={LogoText} />
                  </div>
                </Link>
              ) : (
                <div className="LogoText">
                  <img src={LogoText} />
                </div>
              )}
            </div>
          ) : (
            <select onChange={this.selectGroup.bind(this, false)}>
              {this.props.group === 'メモの検索' ? (
                <option>メモの検索</option>
              ) : null}
              {this.props.group === '次の報告日' ? (
                <option>次の報告日</option>
              ) : null}
              {this.props.group === 'システム管理' ? (
                <option>システム管理</option>
              ) : null}
              <option key={0} value="自分のメモ">
                自分のメモ
              </option>
              {this.props.groups.map(group =>
                this.state.group === group.title ? (
                  <option key={group.id} value={group.title} selected={true}>
                    {group.title}
                  </option>
                ) : (
                  <option key={group.id} value={group.title}>
                    {group.title}
                  </option>
                )
              )}
              {this.props.account.isSystemAdmin ? (
                <option>システム管理</option>
              ) : null}
            </select>
          )}
        </div>

        {!this.props.isVisiter ? (
          <div id="GlobalNavigationRight">
            {/* {this.props.account.isSystemAdmin ? (
              <div className="TriggerFunction">
                {!this.state.createGlobalDisplayed ? (
                  <div
                    id="TriggerCreateGlobal"
                    onMouseUp={this.showCreateGlobal}
                  >
                    <img src={PlusWhite} />
                  </div>
                ) : (
                  <select
                    id="CreateGlobal"
                    onChange={this.selectGroup.bind(this, true)}
                    ref={s => {
                      this.createGlobalSelect = s as HTMLSelectElement;
                    }}
                    onBlur={this.hideCreateGlobal}
                  >
                    <option>グループを選択</option>
                    {groupsAdmin.map(group =>
                      this.state.group === group.title ? (
                        <option
                          key={group.id}
                          value={group.title}
                          selected={true}
                        >
                          {group.title}
                        </option>
                      ) : (
                        <option key={group.id} value={group.title}>
                          {group.title}
                        </option>
                      )
                    )}
                  </select>
                )}
              </div>
            ) : null} */}
            <div className="TriggerFunction">
              <Link to="/search/">
                <img src={Loupe} />
              </Link>
            </div>
            <div className="TriggerFunction">
              <Link to="/deadline/">
                <img src={Calendar} />
              </Link>
            </div>

            {/* <div id="TriggerNotification" onClick={this.toggleNotifications}>
              <img src={Bell} />
              {countNewActivities > 0 ? (
                <span className="Counts">{countNewActivities}</span>
              ) : null}

              {this.state.expandNotifications ? (
                <div>
                  <div id="Activities">
                    {this.props.activities
                      .filter(
                        activity => activity.memberId !== this.props.account.id
                      )
                      .sort((a, b) => (a.created > b.created ? -1 : 1))
                      .map(activity => {
                        const activityMember = this.props.members.find(
                          member => member.id === activity.memberId
                        );
                        if (activityMember !== undefined) {
                          return (
                            <div className="Activity" key={activity.id}>
                              <div className="Image">
                                <img
                                  src={
                                    activityMember.profile !== null
                                      ? activityMember.profile
                                      : Profile
                                  }
                                />
                              </div>
                              {this.renderNotification(activity)}
                            </div>
                          );
                        } else {
                          return null;
                        }
                      })}
                  </div>
                  <div id="ActivitiesBackground" />
                </div>
              ) : null}
            </div> */}
            <Link to={'/settings/account'}>
              <div id="LinkToProfile">
                <img
                  src={
                    this.props.account.profile !== null
                      ? this.props.account.profile
                      : Profile
                  }
                />
              </div>
            </Link>
          </div>
        ) : null}
      </div>
    );
  }

  selectGroup(createAssigned: boolean, e: any) {
    this.setState({
      groupSelected: true,
      group: e.target.value,
      createAssigned
    });
  }

  renderNotification(activity: Activity) {
    const member = this.props.members.find(
      memberCandidate => memberCandidate.id === activity.memberId
    ) as Member;

    const group = this.props.groups.find(
      groupCandidate => groupCandidate.id === activity.groupId
    ) as Group;

    const type =
      activity.type === 'memo'
        ? 'メモ'
        : activity.type === 'wiki'
        ? 'ウィキ'
        : activity.type === 'note'
        ? 'ノート'
        : 'ボード';

    const action = activity.action === 'create' ? '作成' : '更新';
    let to = '/' + group.title + '/' + activity.type + 's';
    if (activity.type === 'memo') {
      to += '#only=' + activity.memoId;
    }

    return (
      <a href={to} target="_blank">
        <div>
          {member.nameLast +
            'さんが' +
            group.title +
            'で' +
            type +
            'を' +
            action +
            'しました。'}
        </div>
      </a>
    );
  }

  toggleNotifications() {
    if (!this.state.expandNotifications) {
      const account = Object.assign({}, this.props.account);
      account.activityChecked = Date.now();
      this.props.updateMember(account);
    }
    this.setState({
      expandNotifications: !this.state.expandNotifications
    });
  }

  showCreateGlobal() {
    this.setState({
      createGlobalDisplayed: true
    });

    setTimeout(() => {
      this.createGlobalSelect.focus();
    }, 10);
  }

  hideCreateGlobal() {
    this.setState({
      createGlobalDisplayed: false
    });
  }
}

const mapStateToProps = (state: any, ownProps: any) => ({
  account: state.Account,
  groups: state.Group,
  members: state.Member,
  activities: state.Activity
});

const mapDispatchToProps = (dispatch: any) => {
  return {
    updateMember(member: Member) {
      dispatch(updateMember(member));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NavigationComponent);



// WEBPACK FOOTER //
// ./src/components/Navigation/global.tsx